
import {catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { FgiBackEndService } from '../fgi-back-end.service';
import { AgenteFinanceiro, LoteAgenteFinanceiroJanela } from '../../model/agente-financeiro.model';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LimiteAgenteFinanceiro, LimiteHonraAgenteFinanceiro } from 'src/app/model/limite-agente-financeiro.model';
import { blockUi, useCache, refreshCache } from "@bndes/bndes-ux4/bndes-angular-utils";

@Injectable({
  providedIn: 'root'
})
export class AgenteFinanceiroService extends FgiBackEndService<AgenteFinanceiro> {

  // @Override (obrigado a sobrescrever. Nao faz sentido para o nosso caso.)
  getNewEntity() {
    return new AgenteFinanceiro();
  }

  // @Override (obrigado a sobrescrever. Nao faz sentido para o nosso caso.)
  protected getResourceURL(): string {
    return 'agentes-financeiros';
  }

 public getAgentesFinanceiros(): Observable<AgenteFinanceiro[]> {
    return this.http.get('rest/front/agentes-financeiros', useCache())
      .pipe(catchError((e) => this.handleError(e)))
      .pipe(
          tap((agentes: AgenteFinanceiro[]) => {
              agentes.sort((agente1, agente2) => agente1.nome >= agente2.nome ? 1 : -1);
          })    
      ) as Observable<AgenteFinanceiro[]>;
  }

  public getAgentesFinanceirosNestaModalidade(refresh?: boolean): Observable<AgenteFinanceiro[]> {
      return this.http.get('rest/front/agentes-financeiros/apenasNestaModalidade', refresh ? refreshCache(): useCache())
        .pipe(catchError((e) => this.handleError(e))) 
        .pipe(
          tap((agentes: AgenteFinanceiro[]) => {
              agentes.sort((agente1, agente2) => agente1.nome >= agente2.nome ? 1 : -1);
          })    
      ) as Observable<AgenteFinanceiro[]>;
  }

   public buscaLimitesFg2(ideTranche: number): Observable<LimiteAgenteFinanceiro[]> {
    return this.http.get(`rest/front/agentes-financeiros/limite/tranche/${ideTranche}`, blockUi()).pipe(
      catchError((e) => this.handleError(e))) as Observable<LimiteAgenteFinanceiro[]>;
   }

   public buscaLimiteFg2(cnpjAgente: string, ideTranche: number): Observable<LimiteAgenteFinanceiro> {
    return this.http.get(`rest/front/agentes-financeiros/${cnpjAgente}/limite/tranche/${ideTranche}`, blockUi()).pipe(
      catchError((e) => this.handleError(e))) as Observable<LimiteAgenteFinanceiro>;
   }

  public buscaLimiteHonraFg2(janelaReferencia: string, ideTranche: number,
      cnpjAgente: string, msgErro404: string): Observable<LimiteHonraAgenteFinanceiro[]> {
    return this.http.get(`rest/front/limite-honra/${cnpjAgente}/limite?nomeJanela=${janelaReferencia}&tranche=${ideTranche}`, blockUi()).pipe(
      catchError((e) => this.handleErrorBuscaLimitesHonraFg2(e, msgErro404))) as Observable<LimiteHonraAgenteFinanceiro[]>;
  }

  public buscaLimitesHonraFg2(janelaReferencia: string, ideTranche: number, msgErro404: string): Observable<LimiteHonraAgenteFinanceiro[]> {
    return this.http.get(`rest/front/limite-honra/limites?nomeJanela=${janelaReferencia}&tranche=${ideTranche}`, blockUi()).pipe(
      catchError((e) => this.handleErrorBuscaLimitesHonraFg2(e, msgErro404))) as Observable<LimiteHonraAgenteFinanceiro[]>;
  }

  private handleErrorBuscaLimitesHonraFg2(error: Response | any, msgErro404: any) {
    if (error && error.status == 404) {
      error.message = msgErro404;
    }
    return this.handleError(error);
  }

  public buscaRelatorioAnalitico(idLimiteHonra: number): Observable<any> {
    return this.http.get(`rest/front/limite-honra/relatorio-analitico/${idLimiteHonra}`,
        { responseType: 'blob' }).pipe(catchError((e) => this.handleError(e)));
  }

  public buscaLimitesAdicionaisFg2(
    ideTranche: number,
    ideLimiteAdicional: number
  ): Observable<LimiteAgenteFinanceiro[]> {

    return this.http.get(
      `rest/front/agentes-financeiros/limite/tranche/${ideTranche}/adicional/${ideLimiteAdicional}`,
      blockUi()
    ).pipe(
      catchError((e) => this.handleError(e))
    ) as Observable<LimiteAgenteFinanceiro[]>;
  }
  
  public buscaLimiteAdicionalFg2(
    cnpjAgente: string,
    ideTranche: number,
    ideLimiteAdicional: number
  ): Observable<LimiteAgenteFinanceiro> {

    return this.http.get(
      `rest/front/agentes-financeiros/${cnpjAgente}/limite/tranche/${ideTranche}/adicional/${ideLimiteAdicional}`,
      blockUi()
    ).pipe(
      catchError((e) => this.handleError(e))
    ) as Observable<LimiteAgenteFinanceiro>;
  }
}
